<app-megamenu></app-megamenu>

<div class="careers-page">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1>Join Our Growing Team</h1>
        <p class="hero-subtitle">
          Build a rewarding career with Complete Pest Control. We're looking for passionate individuals 
          who want to make a difference in their community while growing professionally.
        </p>
        <div class="hero-stats">
          <div class="stat-item">
            <span class="stat-number">{{ openPositions.length }}</span>
            <span class="stat-label">Open Positions</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">15+</span>
            <span class="stat-label">Years Experience</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">1000+</span>
            <span class="stat-label">Happy Customers</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Why Work With Us Section -->
  <div class="benefits-section">
    <div class="container">
      <div class="section-header">
        <h2>Why Work With Complete Pest Control?</h2>
        <p>We believe in investing in our team members and providing an environment where you can thrive.</p>
      </div>

      <div class="benefits-grid">
        <div *ngFor="let benefit of companyBenefits" class="benefit-card">
          <mat-icon class="benefit-icon">{{ benefit.icon }}</mat-icon>
          <h3>{{ benefit.title }}</h3>
          <p>{{ benefit.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Open Positions Section -->
  <div class="positions-section">
    <div class="container">
      <div class="section-header">
        <h2>Current Openings</h2>
        <p>Explore our available positions and find the perfect fit for your career goals.</p>
      </div>

      <div class="positions-grid">
        <div *ngFor="let position of openPositions" class="position-card">
          <mat-card class="job-card" [class.featured]="position.featured">
            <div *ngIf="position.featured" class="featured-badge">
              <mat-icon>star</mat-icon>
              <span>Featured Position</span>
            </div>

            <mat-card-header class="job-header">
              <mat-card-title class="job-title">{{ position.title }}</mat-card-title>
              <mat-card-subtitle class="job-meta">
                <span class="job-department">{{ position.department }}</span>
                <span class="job-type">{{ position.type }}</span>
                <span class="job-location">{{ position.location }}</span>
              </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content class="job-content">
              <div class="job-salary" *ngIf="position.salary">
                <mat-icon>attach_money</mat-icon>
                <span>{{ position.salary }}</span>
              </div>

              <p class="job-description">{{ position.description }}</p>

              <div class="job-section">
                <h4>Key Responsibilities</h4>
                <ul class="job-list">
                  <li *ngFor="let responsibility of position.responsibilities.slice(0, 4)">
                    {{ responsibility }}
                  </li>
                  <li *ngIf="position.responsibilities.length > 4" class="more-items">
                    And {{ position.responsibilities.length - 4 }} more...
                  </li>
                </ul>
              </div>

              <div class="job-section">
                <h4>Requirements</h4>
                <ul class="job-list">
                  <li *ngFor="let requirement of position.requirements.slice(0, 3)">
                    {{ requirement }}
                  </li>
                  <li *ngIf="position.requirements.length > 3" class="more-items">
                    And {{ position.requirements.length - 3 }} more...
                  </li>
                </ul>
              </div>

              <div class="job-section">
                <h4>Benefits</h4>
                <div class="benefits-chips">
                  <mat-chip-set>
                    <mat-chip *ngFor="let benefit of position.benefits.slice(0, 3)">
                      {{ benefit }}
                    </mat-chip>
                  </mat-chip-set>
                  <span *ngIf="position.benefits.length > 3" class="more-benefits">
                    +{{ position.benefits.length - 3 }} more
                  </span>
                </div>
              </div>
            </mat-card-content>

            <mat-card-actions class="job-actions">
              <button mat-raised-button class="apply-btn" (click)="applyForPosition(position)">
                <mat-icon>email</mat-icon>
                Apply Now
              </button>
              <button mat-button class="learn-more-btn" (click)="callPhone()">
                <mat-icon>phone</mat-icon>
                Learn More
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <!-- Application Process Section -->
  <div class="process-section">
    <div class="container">
      <div class="section-header">
        <h2>Our Hiring Process</h2>
        <p>We've streamlined our process to make it easy for you to join our team.</p>
      </div>

      <div class="process-steps">
        <div class="step-item">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>Apply Online</h3>
            <p>Submit your application and resume through email or give us a call to discuss the opportunity.</p>
          </div>
        </div>
        <div class="step-item">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>Initial Interview</h3>
            <p>We'll schedule a phone or in-person interview to learn more about you and your experience.</p>
          </div>
        </div>
        <div class="step-item">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>Final Interview</h3>
            <p>Meet with our team leads to discuss the role in detail and answer any questions you may have.</p>
          </div>
        </div>
        <div class="step-item">
          <div class="step-number">4</div>
          <div class="step-content">
            <h3>Welcome Aboard</h3>
            <p>Complete onboarding, training, and start making a difference in our community!</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- CTA Section -->
  <div class="cta-section">
    <div class="container">
      <div class="cta-content">
        <h2>Ready to Start Your Career?</h2>
        <p>
          Don't see a position that fits? We're always looking for talented individuals to join our team. 
          Send us your resume and let us know how you'd like to contribute to Complete Pest Control.
        </p>
        <div class="cta-actions">
          <button mat-raised-button class="primary-cta" (click)="sendEmail()">
            <mat-icon>email</mat-icon>
            Send Your Resume
          </button>
          <button mat-button class="secondary-cta" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Call {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>